import applyteam from "../../../../assets/images/Home/applyteam.png";
import createteam from "../../../../assets/images/Home/createteam.png";
import ErrorBox from "../../../components/Error/Box";
import { CreateTeam } from "@/components/Dialogs/CreateTeam";
import { Team } from "types";
import Icon from "../../../icons";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { Link } from "react-router-dom";
import ErrorBoundary from "@/ErrorBoundary";
import { useQueryClient } from "@tanstack/react-query";

export default function AppHomeList({  }: {  }) {
    const queryClient = useQueryClient();
    const userteams = queryClient.getQueryState(["teams"]) as any;
    return (
        <>
            <div className="max-h-screen pb-24 overflow-auto p-4 sm:px-32" style={{
                scrollbarWidth: 'none'
            }}>
                <h1 className="text-gray-300 font-semibold text-2xl mb-4">My Teams</h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 w-full gap-8 mb-4">
                    <CreateTeam>
                        <div className="group flex flex-col gap-2 p-2  rounded-lg cursor-pointer relative overflow-hidden h-56">
                            <div className="flex flex-col items-center justify-center text-center gap-2 h-full z-[2] rounded-lg p-4">
                                <img
                                    src={createteam}
                                    alt="team"
                                    className="absolute w-full h-full object-cover z-[-2] transition duration-300 blur-lg group-hover:blur-none group-hover:scale-105"
                                    draggable="false"
                                />
                                <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black opacity-75 hover:scale-105 transition duration-300 z-[1]"></div>
                                <div className="relative flex flex-col items-center p-4 h-full text-center justify-center">
                                    <h1 className="text-2xl text-white font-bold">
                                        Create a Team
                                    </h1>
                                    <h2 className="text-lg text-white font-normal">
                                        Start your journey by creating a team
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </CreateTeam>
                    <div className="group flex flex-col gap-2 p-2 rounded-lg cursor-pointer relative overflow-hidden h-56">
                        <Link to="discover/teams" className="flex flex-col items-center justify-center text-center gap-2 h-full z-[2] rounded-lg p-4">
                            <img
                                src={applyteam}
                                alt="team"
                                className="absolute w-full h-full object-cover z-[-2] transition duration-300 blur-lg group-hover:blur-none group-hover:scale-105"
                                draggable="false"
                            />
                            <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black opacity-75 hover:scale-105 transition duration-300 z-[1]"></div>
                            <div className="relative flex flex-col items-center p-4 h-full text-center justify-center">
                                <h1 className="text-2xl text-white font-bold">
                                    Apply to a Team
                                </h1>
                                <h2 className="text-lg text-white font-normal">
                                    Join a team by applying to one
                                </h2>
                            </div>
                        </Link>
                    </div>
                </div>
                <>
                    {userteams.status != "success" ? (
                        <div className="grid grid-cols-1 sm:grid-cols-2 w-full gap-8">
                            {[...Array(6)].map((_, index) => (
                                <div
                                    key={index}
                                    className="flex flex-col w-full h-full teambox bg-brand-darkest rounded-lg overflow-hidden shadow-lg"
                                    style={{ height: '8rem' }}
                                >
                                    <div className="animate-pulse relative w-full h-full">
                                        <div className="absolute inset-0 bg-brand-back bg-opacity-50"></div>
                                        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-darkest opacity-75"></div>
                                        <div className="relative flex items-center gap-4 p-4 h-full">
                                            <div className="flex items-center justify-center w-16 h-16 rounded text-white bg-gray-600 text-x font-bold"></div>
                                            <div className="flex flex-col gap-2">
                                                <div className="flex items-center gap-2">
                                                    <div className="w-60 h-6 bg-gray-600 rounded"></div>
                                                </div>
                                                <div className="w-32 h-4 bg-gray-600 rounded"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : userteams.isError || userteams.data?.message ? (
                        <ErrorBox message={(userteams.error || userteams.data?.message)?.toString()} />
                    ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 w-full gap-8">
                            {userteams.data.teams.map((team: Team) => (
                                <Link
                                    key={team.id}
                                    to={`/teams/${team.id}`}
                                    className="flex flex-col w-full h-full group teambox bg-brand-darkest rounded-lg overflow-hidden shadow-lg"
                                    style={{ height: '8rem' }}
                                >
                                    <ErrorBoundary>
                                        <div className="relative w-full h-full">
                                            {team.banner && (
                                                <img
                                                    src={team.banner}
                                                    alt={`${team.name} banner`}
                                                    className="absolute inset-0 w-full h-full object-cover group-hover:blur-none transition-all duration-300 blur-md"
                                                />
                                            )}
                                            <div className="absolute inset-0 bg-brand-back bg-opacity-50"></div>
                                            <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-darkest opacity-75"></div>
                                            <div className="relative flex items-center gap-4 p-4 h-full">
                                                {team.profilePicture ? (
                                                    <img
                                                        src={team.profilePicture}
                                                        alt={`${team.name} logo`}
                                                        className="w-16 h-16 rounded"
                                                    />
                                                ) : (
                                                    <div className="flex items-center justify-center w-16 h-16 rounded text-white bg-gray-600 text-x font-bold">
                                                        {team.name.charAt(0).toUpperCase()}
                                                    </div>
                                                )}
                                                <div className="flex flex-col gap-2">
                                                    <div className="flex items-center gap-2">
                                                        <h1 className="text-lg text-gray-200 font-bold">{team.name}</h1>
                                                        {team.isVerified && (
                                                            <Tippy content="Verified Team">
                                                                <div className="items-center text-brand-green">
                                                                    <Icon name="verified" size="24" />
                                                                </div>
                                                            </Tippy>
                                                        )}
                                                    </div>

                                                    <h1 className="text-sm text-gray-400 font-normal">
                                                        {team.memberCount} Members
                                                    </h1>
                                                </div>
                                            </div>
                                        </div>
                                    </ErrorBoundary>
                                </Link>
                            ))}
                        </div>
                    )}

                </>
            </div>
        </>
    );
}
